import {FC} from "react";
import Table from "../../../common/Table";
import {getAuth} from "../../../services/AuthService";
import {IRestTeam, ICategoryGroup} from "../../../helpers/interfaces/ranking";
import {CategoryMatch} from "../../../helpers/interfaces/category";
import {getCategoryMatchesColumns, getCategoryMatchesMobileColumns} from "../../../config/Tables/category";

interface ICategoryMatchesTable {
    groupLabel: string,
    group: ICategoryGroup | undefined,
    day: number,
    groupMatches: CategoryMatch[],
    listaSquadreRiposo: IRestTeam[],
    expandedMatchId?: number | null,
    onToggleExpand?: (id: number | null) => void
}

const CategoryMatchesTable: FC<ICategoryMatchesTable> = (
    {groupLabel, group, day, groupMatches, listaSquadreRiposo, expandedMatchId, onToggleExpand}
) => {
    const auth = getAuth();
    const categoryMatchesColumns = getCategoryMatchesColumns(
        expandedMatchId ?? null,
        onToggleExpand ?? (() => {})
    );
    const categoryMatchesMobileColumns = getCategoryMatchesMobileColumns(
        expandedMatchId ?? null,
        onToggleExpand ?? (() => {})
    );

    return group ? <div className="rank_groups_table fs-6" key={groupLabel}>
        <div className="rank_groups_table fs-6">
            <div className='rank_groups_table'>
                <Table
                    id={`tab_rank_groups_${group.id}_days_${day}_table_${group.id}`}
                    columns={auth ? [...categoryMatchesColumns] : [...categoryMatchesColumns.slice(0, -1)]}
                    columnsMobile={auth ? [...categoryMatchesMobileColumns] : [...categoryMatchesMobileColumns.slice(0, -1)]}
                    data={groupMatches}
                    emptyDataText="Nessuna partita odierna presente"

                />
            </div>
        </div>
        {listaSquadreRiposo?.length > 0 && group?.hasClassifica && (
            <div className="d-flex flex-wrap fs-7 ms-2 mb-2">
                <span>Riposa:{" "}
                    {listaSquadreRiposo.map((s, idx, arr) => (
                        <span key={s.id}>
                            {s.nome}
                            {idx < arr.length - 1 && ', '}
                        </span>
                    ))}
                </span>
            </div>
        )}
        <div id="tab_partite_odierne_caption" className='d-flex flex-wrap fs-7 ms-2'>
            <div className='mb-1 me-2 display-6 fs-6'>
                <i className="fa fa-circle rinviata" aria-hidden="true"/> = Rinviata
            </div>
            <div className='mb-1 me-2 display-6 fs-6'>
                <i className="fa fa-circle in-corso" aria-hidden="true"/> = In corso
            </div>
            <div className='mb-1 me-2 display-6 fs-6'>
                <i className="fa fa-circle sospesa" aria-hidden="true"/> = Sospesa
            </div>
            <div className='mb-1 me-2 display-6 fs-6'>
                <i className="fa fa-circle terminata" aria-hidden="true"/> = Terminata
            </div>
            <div className='mb-1 me-2 display-6 fs-6'>
                <i className="fa fa-circle-o da-giocare" aria-hidden="true"/> = Da giocare
            </div>
        </div>
    </div> : <></>
}

export default CategoryMatchesTable;